<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    /** Corner radius on the DS radius scale: `0` · `2` · `4` (default) · `full`. */
    rounded?: 0 | 2 | 4 | 'full'
  }>(),
  {
    rounded: 4,
  },
)

const ROUNDED_CLASSES: Record<0 | 2 | 4 | 'full', string> = {
  0: 'rounded-0',
  2: 'rounded-2',
  4: 'rounded-4',
  full: 'rounded-full',
}

const roundedClass = computed(() => ROUNDED_CLASSES[props.rounded])
</script>

<template>
  <div
    aria-hidden="true"
    class="skeleton-shimmer size-full motion-safe:animate-shimmer"
    :class="roundedClass"
  ></div>
</template>
